
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_7gmeu_9",
  "child": "awsui_child_18582_7gmeu_13",
  "horizontal": "awsui_horizontal_18582_7gmeu_24",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_7gmeu_28",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_7gmeu_31",
  "horizontal-xs": "awsui_horizontal-xs_18582_7gmeu_34",
  "horizontal-s": "awsui_horizontal-s_18582_7gmeu_37",
  "horizontal-m": "awsui_horizontal-m_18582_7gmeu_40",
  "horizontal-l": "awsui_horizontal-l_18582_7gmeu_43",
  "horizontal-xl": "awsui_horizontal-xl_18582_7gmeu_46",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_7gmeu_49",
  "vertical": "awsui_vertical_18582_7gmeu_56",
  "vertical-xxxs": "awsui_vertical-xxxs_18582_7gmeu_59",
  "vertical-xxs": "awsui_vertical-xxs_18582_7gmeu_62",
  "vertical-xs": "awsui_vertical-xs_18582_7gmeu_65",
  "vertical-s": "awsui_vertical-s_18582_7gmeu_68",
  "vertical-m": "awsui_vertical-m_18582_7gmeu_71",
  "vertical-l": "awsui_vertical-l_18582_7gmeu_74",
  "vertical-xl": "awsui_vertical-xl_18582_7gmeu_77",
  "vertical-xxl": "awsui_vertical-xxl_18582_7gmeu_80",
  "align-center": "awsui_align-center_18582_7gmeu_84",
  "align-start": "awsui_align-start_18582_7gmeu_88",
  "align-end": "awsui_align-end_18582_7gmeu_92",
  "child-aligned": "awsui_child-aligned_18582_7gmeu_96"
};
  